import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentScheduleRBAC = {
  pageID: '13b9a3b8f50319f181186cac2acd7441',
  elementID: {
    ViewList: 'f72660a777e04a6ec1c3fcc6916e951b',
    ButtonAdd: 'a4dd9eac43d3ef3f453c1b4fe4c8bcb9',
    ButtonEdit: '0aed8b91ac17d947846599522d6d5cae',
    ButtonDelete: '2a5e8df553f9160c158a31b485b9d9ab',
  },
} as const

export const useRBACReplenishmentSchedulePage = createUseRBAC(ReplenishmentScheduleRBAC.elementID)

export type UseRBACReplenishmentSchedulePageType = ReturnType<
  typeof useRBACReplenishmentSchedulePage
>
